export default "__VITE_ASSET__BL9u3k93__"